export var DAYS_OF_WEEK = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
export var DEFAULT_TERRITORY = '001';